import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { ButtonVariant, DsButtonModule } from '@bmw-ds/components';
import { NGXLogger } from 'ngx-logger';

import { useI18n } from '../../../i18n/services/i18n.service';
import { AddCustomerToVehicleSize } from './add-customer-to-vehicle.model';
import { AddCustomerToVehicleModalWrapper } from './modal/add-customer-to-vehicle-modal.wrapper';

@Component({
  selector: 'cdf-add-customer-to-vehicle',
  imports: [DsButtonModule, AddCustomerToVehicleModalWrapper],
  template: `
    <ds-button [size]="size()" icon="user_add" [variant]="variant() ?? 'primary'" (click)="handleButton()">
      {{ i18n('vehicles.addCustomerToVehicle.buttonText') }}
    </ds-button>

    @if (vin(); as vin) {
      <cdf-add-customer-to-vehicle-modal-wrapper
        [(open)]="modalOpen"
        [vin]="vin"
        (completeModal)="addedCustomer.emit($event)"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCustomerToVehicleContainer {
  protected readonly i18n = useI18n();
  private readonly logger = inject(NGXLogger);

  readonly vin = input<string>();
  readonly size = input<AddCustomerToVehicleSize>('md');
  readonly variant = input<ButtonVariant | undefined>();

  readonly addedCustomer = output<string>();

  protected handleButton() {
    if (!this.vin()) {
      this.logger.error('#CDFTF0254 Add customer to vehicle button pressed without VIN provided');
      return;
    }
    this.modalOpen.set(true);
  }

  protected readonly modalOpen = signal(false);
}
